module.exports = __webpack_public_path__ + "img/icon-trash-red.3fe5db4d.svg";